import { useQuery } from "@tanstack/react-query";
import { useMemo } from "react";
import { getAuthorized } from "@/lib/fetch";
import { Field } from "@/features/FilterTable/types";

function useDateOptions(
  client: string,
  tableName: string,
  initialFields: Field[],
) {
  const { data: dateOptions, error } = useQuery({
    queryKey: [client, tableName, "dates"],
    queryFn: async () => {
      return getAuthorized(
        `${import.meta.env.VITE_BACKEND_URL}/${client}/${tableName}/dates`,
      )
        .then((response) => response.json())
        .then((res) => {
          return res.map((date: string) => ({
            label: date,
            value: date,
          }));
        });
    },
  });

  const fields = useMemo(() => {
    return initialFields.map((field) => {
      if (field.name === "date_equals" && dateOptions) {
        return { ...field, options: dateOptions } as Field;
      }
      return field;
    });
  }, [initialFields, dateOptions]);

  return { fields, error };
}

export default useDateOptions;
